import React from "react";

// Pulls a leading icon element (lucide / svg) out of a dialog title so it can sit in the header tile.
export function splitLeadIcon(children) {
  const arr = React.Children.toArray(children);
  const first = arr[0];
  if (first && React.isValidElement(first) && typeof first.type !== "string" && arr.length > 1) {
    return [React.cloneElement(first, { size: 18, className: "" }), arr.slice(1)];
  }
  return [null, children];
}
